import { Button } from '@/components/ui/button';
import {
  Dialog,
  DialogTrigger,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogClose
} from '@/components/ui/dialog';
import { Cross2Icon } from '@radix-ui/react-icons';
import { cn } from '@/lib/utils';
import { Icons } from '@/components/ui/icons';

export default function Login() {
  return (
    <Dialog>
      <DialogTrigger asChild>
        <Button
          className={cn(
            'group rounded-full w-12 h-12 flex items-center justify-center p-0 shadow-lg border-2 border-primary',
            'bg-primary text-primary-foreground',
            'transition-all duration-300 ease-in-out',
            'focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2',
            'active:scale-95',
            'dark:bg-primary dark:text-primary-foreground',
            'hover:bg-primary-foreground hover:text-primary',
            'hover:shadow-xl',
            'hover:border-primary-foreground',
            'hover:scale-110',
            'focus:bg-primary-foreground focus:text-primary',
            'active:bg-primary/80',
            'active:text-primary-foreground',
            'transition-transform',
          )}
          style={{ minWidth: 0 }}
          aria-label="Login"
        >
          <span
            className={cn(
              'transition-transform duration-300',
              'group-hover:rotate-[-20deg] group-active:scale-110',
              'group-hover:text-blue-400 group-hover:bg-blue-100',
              'group-focus:text-blue-500',
              'group-active:text-blue-700'
            )}
          >
            <Icons.user className="w-6 h-6" />
          </span>
        </Button>
      </DialogTrigger>
      <DialogContent
        className={cn(
          'p-0 overflow-hidden',
          'w-[90vw] max-w-[700px] h-[90vh] max-h-[520px]',
          'flex flex-col items-stretch justify-stretch',
          'sm:w-[700px] sm:h-[520px]',
          'transition-all duration-300 ease-in-out'
        )}
        style={{ minWidth: 0, minHeight: 0 }}
      >
        {/* Removido DialogHeader/DialogTitle para não exibir título no modal */}
        <DialogClose asChild>
          <button
            className={cn(
              'absolute right-4 top-4 z-10 flex items-center justify-center',
              'rounded-full w-10 h-10 transition-colors',
              'bg-background text-foreground border border-border',
              'hover:bg-foreground hover:text-background',
              'focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2',
              'active:scale-95',
              'dark:bg-background dark:text-foreground dark:hover:bg-foreground dark:hover:text-background'
            )}
            aria-label="Fechar"
            type="button"
          >
            <Cross2Icon className="h-5 w-5" />
          </button>
        </DialogClose>
        {/* Removido iframe, exibir apenas link externo */}
        <div className="flex flex-col items-center justify-center h-full w-full p-8">
          <a
            href="https://chat.niteroi.city/login"
            target="_blank"
            rel="noopener noreferrer"
            className="text-primary underline text-lg font-semibold hover:text-primary-foreground transition-colors"
          >
            Acessar Login Niterói City
          </a>
          <p className="mt-4 text-muted-foreground text-sm text-center">O login será aberto em uma nova janela.</p>
        </div>
      </DialogContent>
    </Dialog>
  );
} 